// BEAM UI primitive — Badge.
// Status pill keyed by StatusKey (draft|sent|paid|overdue|inProgress). Copper is never
// a status, so it is intentionally not selectable here. Consumes only theme tokens.
import React from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { theme, type StatusKey } from '../../theme';
import { Text } from './Text';

const LABELS: Record<StatusKey, string> = {
  draft: 'Draft',
  sent: 'Sent',
  paid: 'Paid',
  overdue: 'Overdue',
  inProgress: 'In progress',
};

type BadgeProps = {
  status: StatusKey;
  /** Override the default label (e.g. "Approved" mapped to the paid/done style). */
  label?: string;
  style?: StyleProp<ViewStyle>;
};

export function Badge({ status, label, style }: BadgeProps) {
  const tone = theme.status[status];
  return (
    <View style={[styles.badge, { backgroundColor: tone.bg }, style]}>
      <Text variant="label" style={{ color: tone.fg }}>
        {label ?? LABELS[status]}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    alignSelf: 'flex-start',
    paddingHorizontal: theme.spacing.sm,
    paddingVertical: theme.spacing.xs,
    borderRadius: theme.radius.pill,
  },
});
